module.exports = __webpack_public_path__ + "static/user-research-click-368510258f3ddda56a34f90d3602b2cd.png";